<template>
  <div v-if="$store.state.isLoading == false" class="membereditnew formular">

    <div class="form-container">
        <p>Benutzerdaten</p>
        <ul class="flex-outer">
          <li>
            <label for="loginname">Benutzername:</label>
            <input type="text" id="loginname" spellcheck="false">
          </li>
          <li>
            <label for="password">Passwort:</label>
            <input type="text" id="password" spellcheck="false">
          </li>
          <li>
            <label for="email">E-Mail Adresse:</label>
            <input type="email" id="email" spellcheck="false">
          </li>
        </ul>
    </div>

    <div class="form-container">
        <p>Persönliche Daten</p>
        <ul class="flex-outer">
          <li>
            <label for="prename">Vorname:</label>
            <input type="text" id="prename" spellcheck="false">
          </li>
          <li>
            <label for="familyname">Nachname:</label>
            <input type="text" id="familyname" spellcheck="false">
          </li>
          <li>
            <label for="familyname">Multiselect:</label>
            <!-- <multi-select :options="chooseMember"
                            id="value"
                          name="text"
                            :selected-options="memberSelectedMulti"
                            placeholder="select item"
                            @select="onSelect">
              </multi-select> -->
          </li>
        </ul>
    </div>

  </div>
</template>

<script>
import EventBus from "../bus";
import functions from '../mixins/functions';



export default {
  name: 'membereditnew',
  mixins: [functions],
  props: {
      member: {
          type: Object,
          default: () => ({}),
      },
  },
  data () {
    return {
      memberSelectedMulti: [{value: 3, text: "test"}],
      lastSelectItem: {}
    }
  },
  created: function (){
    this.resetBar();
  },
  mounted: function () {
    EventBus.$emit("checklogin")
    if(this.$route.params.member_id < 0){
      this.$store.state.heading = "Mitglied editieren"
      this.$store.state.isLoading = true
      console.log(this.$route.params.member_id)
      this.$http.get('/api/get_member.pl', {params:  {member_id: this.$route.params.member_id}}).then(function (response) {
          this.result = response.data.member
          console.log(response.data);
          this.$store.state.isLoading = false
        });
    }
    else{
      this.$store.state.heading = "Mitglied hinzufügen"

    }
    
    
  },
  methods: {
  
  },
  components: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>



// WEBPACK FOOTER //
// src/pages/MemberEditNew.vue